import { Injectable } from '@angular/core';
import { PartnerServiceInterface } from '@galaxy/partner';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerService implements PartnerServiceInterface {
  getPartnerId(): Observable<string> {
    return of('VA');
  }
}
